import { Component, inject } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LanguageSwitcherComponent } from '../language-switcher/language-switcher.component';
import { Languages } from '../../types/language-types';
import { TranslocoService } from '@jsverse/transloco';

interface AppInitialSetupSettings {
  coloredTableButtons: boolean
  frostedGlass: boolean
  language: Languages
}

@Component({
  selector: 'pixl-app-setup',
  imports: [
    MatDividerModule,
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    LanguageSwitcherComponent
  ],
  templateUrl: './app-setup.component.html',
  styleUrl: './app-setup.component.scss'
})
export class AppSetupComponent {
  private readonly dialogRef = inject(MatDialogRef<AppSetupComponent>);
  private localStorageService = inject(LocalStorageService);
  private translocoService = inject(TranslocoService); // Hinzugefügt
  private fb = inject(FormBuilder);
  private initialSettings: AppInitialSetupSettings;
  public settingsForm: FormGroup;

  constructor() {
    const currentButtons = this.localStorageService.getItem<boolean>('coloredTableButtons') ?? true;
    const currentGlass = this.localStorageService.getItem<boolean>('frostedGlass') ?? true;
    const currentLanguage = this.localStorageService.getItem<Languages>('language') ?? 'de';

    this.initialSettings = {
      coloredTableButtons: currentButtons,
      frostedGlass: currentGlass,
      language: currentLanguage
    };

    this.settingsForm = this.fb.group({
      coloredTableButtons: new FormControl(currentButtons),
      frostedGlass: new FormControl(currentGlass)
    });

    this.settingsForm.valueChanges.subscribe((values: Partial<AppInitialSetupSettings>) => {
      Object.entries(values).forEach(([key, value]) => {
        if (value !== undefined) {
          this.localStorageService.setItem(key, value);
        }
      });
    });
  }

  public onCancel() {
    Object.entries(this.initialSettings).forEach(([key, value]) => {
      this.localStorageService.setItem(key, value);
    });
    this.translocoService.setActiveLang(this.initialSettings.language);
    this.dialogRef.close(false);
  }

  public onSave() {
    if (this.settingsForm.invalid) {
      return;
    };
    this.dialogRef.close(true);
  }
}
